export const paths = {
  index: '/',
  dashboard: {
    index: '/dashboard',
    terms: '/dashboard/terms',
    rewards: '/dashboard/rewards',
    manual: '/dashboard/manual'
  },
  login: '/login',
  signUp: '/signup',
  components: {
    index: '/components',
    dataDisplay: {
      detailLists: '/components/data-display/detail-lists',
      tables: '/components/data-display/tables',
      quickStats: '/components/data-display/quick-stats'
    },
    lists: {
      groupedLists: '/components/lists/grouped-lists',
      gridLists: '/components/lists/grid-lists'
    },
    forms: '/components/forms',
    modals: '/components/modals',
    charts: '/components/charts',
    buttons: '/components/buttons',
    typography: '/components/typography',
    colors: '/components/colors',
    inputs: '/components/inputs'
  },
  401: '/401',
  404: '/404',
  500: '/500'
};
